import { Space, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ExternalResourceAvatar from '../../common/ExternalResourceAvatar';
import { FileOutlined, LinkOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ResourcesList = ({ resources, disabled = true }) => {
    const { t } = useTranslation();
    return (
        <Space direction="vertical">
            <Text disabled={disabled} strong>
                {t('workbench.lessons.dashboard.resources')}
            </Text>

            {resources.file.map((resource) => (
                <ExternalResourceAvatar
                    key={resource.id}
                    url={resource.url}
                    icon={<FileOutlined />}
                    title={resource.title}
                    disabled={disabled}
                />
            ))}
            {resources.link.map((resource) => (
                <ExternalResourceAvatar
                    key={resource.id}
                    url={resource.url}
                    icon={<LinkOutlined />}
                    title={resource.title}
                    disabled={disabled}
                />
            ))}
        </Space>
    );
};

export default ResourcesList;
